var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dh-psy-animated-image"},[_c('div',{staticClass:"dh-psy-animated-image__img",style:(_vm.opacity),attrs:{"aria-hidden":""}},[_c('SrcSet',{attrs:{"imageId":_vm.imageId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }